import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

declare var document: any;

export enum ExternalScript {
  ProductsContactForm
}

interface Scripts {
  name: ExternalScript;
  src?: string;
  loaded?: boolean;
  status?: string;
  promise?: Promise<Scripts>;
}

export const ScriptStore: Scripts[] = [
  {name: ExternalScript.ProductsContactForm, src: environment.productContactFormWidgetUrl}
];

@Injectable({
  providedIn: 'root'
})
export class ScriptLoadService {

  private scripts: {[T in ExternalScript]?: Scripts } = {};

  constructor() {
    ScriptStore.forEach((script: Scripts) => {
      this.scripts[script.name] = {
        name: script.name,
        loaded: false,
        src: script.src
      };
    });
  }

  load(...scripts: ExternalScript[]): Promise<Scripts[]> {
    const promises: Promise<Scripts>[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: ExternalScript): Promise<Scripts> {
    const extScript = this.scripts[name];
    if (!extScript.promise) {
      extScript.promise =  new Promise((resolve, reject) => {
        if (extScript.loaded) {
          resolve({name, loaded: true, status: 'Already Loaded'});
        } else {
          const script = document.createElement('script') as HTMLScriptElement;
          script.type = 'text/javascript';
          script.src = extScript.src;
          script.async = true;
          script.onload = () => {
            extScript.loaded = true;
            resolve({name, loaded: true, status: 'Loaded'});
          };
          script.onerror = (error: any) => {
            extScript.promise = null;
            resolve({name, loaded: false, status: 'Loaded'});
          }
          document.getElementsByTagName('head')[0].appendChild(script);
        }
      });
    }
    return extScript.promise;
  }

}
